import React from "react";
import UpcommingBody from "../components/bidding/upcommingPosts";
import SeoMeta from "../components/meta";

export default function Bidding() {
  return (
    <>
      <SeoMeta
        title="Upcoming Biddings | FameWheels"
        desc="Explore the new and used cars at the the car auction in Pakistan. Famewheels has provided a platform for live car bidding in which you can bid on your favorite car and also check Famewheels Auction cars in Karachi for reliable and affordable cars."
        url="upcomming"
      />
      <UpcommingBody />
    </>
  );
}
